import LoginPopUp from "./loginPopup";

export default function LoginPopupContainer() {
  return (
    <div className="CONTAINER || w-full  7:mt-20 pb-14 11:pb-10 ||
     5:flex justify-center">
      <LoginPopUp/>
    </div>
  );
}
